export const isDevAuthEnabled = () => {
  // SECURITY: Dev auth DISABLED in production - only enable via environment variable
  // To enable locally: set REACT_APP_DEV_AUTH=true
  return process.env.REACT_APP_DEV_AUTH === 'true' && process.env.NODE_ENV === 'development';
};

export const devSignIn = ({ email, name }) => {
  const user = {
    user_id: `dev_${Math.random().toString(36).slice(2, 10)}`,
    email: email || 'dev@example.com',
    name: name || 'Dev User',
    created_at: new Date().toISOString(),
    role: 'owner',
    picture: '',
  };
  const token = `dev-token-${Math.random().toString(36).slice(2)}`;
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
  return { token, user };
};